
const French = {
    "form.isRequired": "Le champ {name} est obligatoire !",
    "form.OTPLabel": "Code de vérification par e-mail",
    "form.OTPInputValidMessage": "Réussi",
    "form.OTPInputInvalidMessage": "Code à usage unique incorrect",
    "form.OTPWaitSecondsLabel": "Renvoyer ({waitOtpSeconds}s)",
    "form.OTPSendLabel": "Envoyer le code à usage unique",
    "form.OTPSendSuccessLabel": "Le code de vérification a été envoyé à votre adresse e-mail avec succès !",
    "form.OTPTips": "Veuillez entrer un code à usage unique valide.",
    "form.selectInputLabel": "Rechercher...",
    "form.uploadBtn": "TÉLÉCHARGER",
    "form.uploadSizeTips": "Les fichiers doivent être inférieurs à 5 Mo.",
    "form.uploadTypeTips": "Types de fichiers autorisés : png, gif, jpg, jpeg, pdf.",
    "form.uploadNumTips": "Vous devez télécharger un fichier.",
    "form.isRequiredAccept": "Vous devez accepter ceci pour continuer.",
    "form.sendButton": "ENVOYER",
    "form.isEmail": "Veuillez entrer une adresse e-mail valide",
    "form.isSerialNumber": "Veuillez entrer 13 caractères dans {name}.",
    "form.categoryPlaceholder": "- Sélectionnez la catégorie du produit -",
    "form.seriesPlaceholder": "- Sélectionnez la série du produit -",
    "form.skuPlaceholder": "- Référence (SKU) -",
    "form.sendSuccessMsg": "Envoyé avec succès !",

    "warrantyPeriod.checkTitle": "Check Warranty Period",
    "warrantyPeriod.checkDescription": "Please enter your email and serial number to check the warranty period.",
    "warrantyPeriod.emailLabel": "Email",
    "warrantyPeriod.emailPlaceholder": "Enter Email",
    "warrantyPeriod.serialNumberLabel": "Serial Number",
    "warrantyPeriod.serialNumberPlaceholder": "Enter Serial Number",
    "warrantyPeriod.checkButton": "Check",
    "warrantyPeriod.sendSuccessfulLabel": "Send Successfully! please check your email",
    "warrantyPeriod.checkNoRecordLabel": "Sorry, no record was found!",
}
export {
    French
}   